//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DetailsDialog',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      where: {
        page: 1,
        limit: 15
      },
      tableData: [],
      total: 0,
      testAccess: true,
      assessInfo: {}
    };
  },
  watch: {
    config: {
      handler: function handler(nVal) {
        this.tableData = nVal.data.info;
        this.assessInfo = nVal.data;
      },
      deep: true
    }
  },
  methods: {
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.tableData = [];
    },
    sum: function sum(index) {
      var _this = this;
      var number = 0;
      if (this.assessInfo.types == 0) {
        this.tableData[index].target.forEach(function (val) {
          number += Number(_this.tableData[index].ratio * val.ratio * (val.score ? val.score : 0) / 10000);
        });
        number = (Number(this.assessInfo.total) * number / 100).toFixed(2);
      } else {
        this.tableData[index].target.forEach(function (val) {
          number += Number(val.score ? val.score : 0);
        });
      }
      this.tableData[index].score = number;
      return number;
    },
    totalSum: function totalSum() {
      var number = 0;
      this.tableData.forEach(function (val) {
        number += Number(val.score);
      });
      number = number.toFixed(2);
      this.total = number;
      return number;
    }
  }
};